"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NamePlateReportPage = exports.NamePlateReportPageActions = void 0;
var namePlateReportPageActions_1 = require("./namePlateReportPageActions");
exports.NamePlateReportPageActions = namePlateReportPageActions_1.default;
var namePlateReportPage_1 = require("./namePlateReportPage");
exports.NamePlateReportPage = namePlateReportPage_1.default;
